import { sql } from "../utils";

export const migration001 = sql`
  CREATE TABLE IF NOT EXISTS smart_contexts (
    id UUID PRIMARY KEY,
    associated_space_account_id UUID NOT NULL,
    payload_json JSONB NOT NULL,
    created_at TIMESTAMPTZ,
    updated_at TIMESTAMPTZ
  );

  CREATE TABLE IF NOT EXISTS smart_views (
    id UUID PRIMARY KEY,
    associated_space_account_id UUID NOT NULL,
    smart_context_id UUID NOT NULL,
    derived_kind TEXT,
    derived_internal_label TEXT,
    value_json JSONB NOT NULL,
    has_found_more BOOLEAN DEFAULT FALSE,
    refreshed_at TIMESTAMPTZ,
    created_at TIMESTAMPTZ,
    updated_at TIMESTAMPTZ
  );

  CREATE TABLE IF NOT EXISTS smart_cards (
    id UUID PRIMARY KEY,
    associated_space_account_id UUID NOT NULL,
    smart_context_id UUID NOT NULL,
    smart_view_id UUID NOT NULL,
    sort_key TEXT,
    added_by_space_account_id UUID,
    derived_kind TEXT,
    derived_internal_label TEXT,
    originated_from_find_more BOOLEAN DEFAULT FALSE,
    value_json JSONB NOT NULL,
    refreshed_at TIMESTAMPTZ,
    created_at TIMESTAMPTZ,
    updated_at TIMESTAMPTZ
  );

  CREATE INDEX IF NOT EXISTS idx_smart_views_context_id ON smart_views (smart_context_id);
  CREATE INDEX IF NOT EXISTS idx_smart_cards_view_id ON smart_cards (smart_view_id);
  CREATE INDEX IF NOT EXISTS idx_smart_cards_context_id ON smart_cards (smart_context_id);
`;
